import {IconAgent, IconLock, IconMoney, Group} from "../../assets/icons";
import {AppRoutes} from "../../Router";
import {useNavigate} from 'react-router-dom';
import "./MenuAgent.scss";
import {useIntl} from "react-intl";
import {useLoginContext} from "../../hooks/useLoginContext";
import {useRequestContext} from "../../hooks/useRequestContext";
import ResponsiveAppBar from "../../components/shared/Menubar/ResponsiveAppBar";
import {Fab} from "@mui/material";
import {ArrowBack} from "@mui/icons-material";

export function MenuAgent() {
    const {user} = useLoginContext();
    const {setRequest} = useRequestContext();
    const intl = useIntl();
    const navigate = useNavigate();
    const isAdmin = user.idProfile === '3';
    const adminLabel = "Administraci\u00f3n de Usuarios";

    const iniciarSimulacion = () => {
        localStorage.removeItem('person');
        localStorage.removeItem('personaValidada');
        localStorage.removeItem('codeudor');
        setRequest({
            searchANI: false,
            errorConsulta: false,
            nameProduct: '',
            priceProduct: '',
            codProduct: '',
            imagemoto: '',
        });
        navigate(AppRoutes.HOME, {replace: true});
    };

    const handleSubmit = () => {
        if (user.idProfile === '4') {
            iniciarSimulacion();
        } else {
            navigate(AppRoutes.LOGINAUTO, {replace: true});
        }
    };

    const handleSubmit1 = () => {
        sessionStorage.removeItem('cambioAdm');
        navigate(AppRoutes.CHANGE, {replace: true});
    };

    const handleSubmit2 = () => {
        navigate(AppRoutes.SOLICITUDES_DE_CREDITO, {replace: true});
    };

    const handleUsersAdmin = () => {
        navigate(AppRoutes.USUARIOS_PLATAFORM, {replace: true});
    };

    const handleSubmitBack = () => {
        navigate(AppRoutes.PROFILE_OPTIONS, {replace: true});
    };

    return (
        <div className="menu-agent-page">
            <ResponsiveAppBar/>
            <main className="menu-agent-main">
                <div className="menu-agent-toolbar">
                    <Fab
                        variant="extended"
                        color="neutral"
                        aria-label={intl.formatMessage({id: "button_back"})}
                        onClick={handleSubmitBack}
                        className="menu-agent-back-button hooverButtonRed"
                    >
                        <ArrowBack sx={{mr: 1}} className="hooverButtonRedsvg"/>
                        {intl.formatMessage({id: "button_back"})}
                    </Fab>
                </div>

                <section className="menu-agent-panel" aria-labelledby="menu-agent-title">
                    <div className="menu-agent-heading">
                        <div className="menu-agent-title" id="menu-agent-title">
                            {`${intl.formatMessage({id: "welcome"})} ${" " + user.idUser}`}
                        </div>
                        <div className="menu-agent-subtitle">
                            {intl.formatMessage({id: "how_can_we_help_you_today"})}
                        </div>
                    </div>

                    <div className="menu-cards-container">
                        {isAdmin ? (
                            <button type="button" className="menu-card" onClick={handleUsersAdmin}>
                                <span className="menu-card-icon-frame">
                                    <Group className="menu-card-icon"/>
                                </span>
                                <span className="menu-agent-card-label">{adminLabel}</span>
                            </button>
                        ) : (
                            <>
                                <button type="button" className="menu-card" onClick={handleSubmit1}>
                                    <span className="menu-card-icon-frame">
                                        <IconLock className="menu-card-icon"/>
                                    </span>
                                    <span className="menu-agent-card-label">
                                        {intl.formatMessage({id: "change_of_password"})}
                                    </span>
                                </button>
                                <button type="button" className="menu-card" onClick={handleSubmit2}>
                                    <span className="menu-card-icon-frame">
                                        <IconMoney className="menu-card-icon"/>
                                    </span>
                                    <span className="menu-agent-card-label">
                                        {intl.formatMessage({id: "credit_applications"})}
                                    </span>
                                </button>
                                {user.idProfile !== '1' && (
                                    <button type="button" className="menu-card" onClick={handleSubmit}>
                                        <span className="menu-card-icon-frame">
                                            <IconAgent className="menu-card-icon"/>
                                        </span>
                                        <span className="menu-agent-card-label">
                                            {intl.formatMessage({id: "manage_credit"})}
                                        </span>
                                    </button>
                                )}
                            </>
                        )}
                    </div>
                </section>
            </main>
        </div>
    )
}
